import React from 'react';
import Dispatcher from '../dispatcher';
import RefundRestrictions from './refundRestrictions'
import TransactionStore from '../stores/transaction-store';
import TransactionDetailHeader from './transaction-detail-header';
import BackLinkHeader from './back-link-header';
import PurchaseItem from './purchase-item';
import RefundRequest from './refund-request';
import {VstLoader} from 'vstui';
import Utils from '../utils/utils';

class TransactionDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {transaction: TransactionStore.get(props.orderNumber)};
  }

  _onTransactionChange = () => {
    let state = {transaction: TransactionStore.get(this.props.orderNumber)};
    this.setState(state);
  }

  componentDidMount() {
    Dispatcher.on(Dispatcher.TRANSACTION_STORE_CHANGE, this._onTransactionChange);
  }

  componentWillUnmount() {
    Dispatcher.removeListener(Dispatcher.TRANSACTION_STORE_CHANGE, this._onTransactionChange);
  }

  _renderLineItems() {
    return this.state.transaction.purchaseItems.map((item) =>{
      return( <PurchaseItem transaction={this.state.transaction}
                            item={item}
                            hideright={false}
                            key={`purchase-item-${item.isbn}`} /> );
    });
  }

  render() {
    let t = this.state.transaction
      , body;

    if(t === undefined){
      body = <div className="deck"><VstLoader /></div>;
    }else{
      const {orderNumber, refundItemNumber, refundRestrictions} = this.props;
      body = (
        <div>
          <div className="deck" key={`transaction-detail-${t.number}`}>
            <TransactionDetailHeader transaction={t} />

            { this._renderLineItems() }
          </div>
          { refundItemNumber && <RefundRequest transaction={t} item={t.purchaseItems.find((item)=> item.isbn === refundItemNumber)} />}
          <RefundRestrictions open={refundRestrictions} bulk={t.bulk} orderNumber={orderNumber} />
        </div>
       );
    }
    return(
      <div className="page transaction-detail">
        <BackLinkHeader alt={i18n.t('purchases.back')} href="#/transactions" title={i18n.t('transactions.purchase-details')} />
        { body }
      </div>
    );
  }
}

export default TransactionDetail;
